<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title>Customers</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    @if (isLoading && !paginatedCustomers) {
        <div class="loader" sxCol sxAlign="center" sxGap="10px">
            <ion-spinner></ion-spinner>
            <p sxTextSize="medium" sxColor="two">Loading customers...</p>
        </div>
    }
    @if (!isLoading || paginatedCustomers) {
    <div sxPadding="medium" sxCol sxGap="10px" sxMaxWidth="800px" sxMargin="0 auto">

        <div class="table-navigator">
            <div class="search-wrapper" sxAlign="center" sxBorderColor="one" sxBorderWidth="0 1px 0 0" sxRow
                sxWidth="full" sxMaxWidth="300px" sxGap="10px" sxPadding="0 10px 0 0">
                <ion-searchbar sxWidth="fill" mode="ios" (keyup.enter)="search()"
                    [(ngModel)]="searchInput"></ion-searchbar>
                <button class="search-button" (click)="search()">Search</button>
            </div>

            @if (paginatedCustomers) {
            <div sxRow sxAlign="center" sxGap="10px" sxWidth>
                <pagination-box [paginatedResponse]="paginatedCustomers"
                    (changePage)="loadCustomers($event)"></pagination-box>
            </div>
            }


        </div>

        @for (customer of paginatedCustomers?.docs ?? []; track customer._id) {
        <div sxBackground="light" sxRadius="medium" sxPadding="medium" sxRow sxAlign="center" sxGap="10px"
            sxDistribution="spaceBetween">

            <div class="flex flex-row gap-2 items-center">
                <avatar-round [title]="customer.targetAccount.name"
                    [imageUrl]="customer.targetAccount.displayPictureUrl" [size]="40"></avatar-round>

                <ion-label>
                    {{ customer.targetAccount.name }}
                </ion-label>
            </div>

            <div class="flex flex-row gap-2 items-center justify-end">
                @if (customer?.targetAccount?.email) {
                <div class="flex flex-row gap-2 items-center">
                    <p class="text-sm text-gray-500">{{ customer.targetAccount.email }}</p>
                    <button class="icon-btn" (click)="openEmail(customer.targetAccount.email)">
                        <ion-icon name="mail-outline"></ion-icon>
                    </button>
                </div>

                }

                @if (customer?.targetAccount?.phoneNumber) {
                <div class="flex flex-row gap-2 items-center">
                    <p class="text-sm text-gray-500">{{ customer.targetAccount.phoneNumber | formatPhone }}</p>
                    <button class="icon-btn" (click)="openWhatsApp(customer.targetAccount.phoneNumber)">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </button>
                </div>

                }

            </div>

            <!-- 
            <ion-button fill="clear" (click)="viewCustomer(customer._id)">
                <ion-icon name="eye-outline"></ion-icon>
            </ion-button> -->
        </div>
        }
    </div>
    }
</ion-content>